import React from "react";
import "../../styles/Navbar.css";
import { FaHome, FaLaptop } from "react-icons/fa";
import { BiBookContent, BiServer, BiEnvelope } from "react-icons/bi";
import { FiUser } from "react-icons/fi";
import { Link } from "react-scroll";
import ProfileImg from "../../images/profile-small.webp";
import NavLinks from "./NavLinks";
import { motion } from "framer-motion";
import { AnimatePresence } from "framer-motion";

const navVariants = {
	hidden: {
		opacity: 0,
		transition: {
			delay: 0.5,
			staggerChildren: 0.2,
			staggerDirection: -1,
		},
	},
	visible: {
		opacity: 1,
		transition: {
			duration: 0.5,
			staggerChildren: 0.2,
			staggerDirection: 1,
		},
	},
};

const Navbar = ({ nav, handleNav }) => {
	return (
		<AnimatePresence>
			<motion.nav
				initial={{ width: "0" }}
				animate={
					nav ? { width: "300px" } : { width: "0", transition: { delay: 1 } }
				}
				className={nav ? "navbar active" : "navbar"}>
				<motion.div
					initial='hidden'
					whileInView={nav ? "visible" : "hidden"}
					variants={navVariants}
					exit='hidden'
					className='navbar-container'>
					<div className='top-details'>
						<div className='img__cover'>
							<img src={ProfileImg} alt='Main' className='profile-pic-small' />
						</div>
						<Link
							activeClass='active'
							spy={true}
							smooth={true}
							offset={0}
							duration={500}
							onClick={handleNav}
							to='home'
							href="#"
							className='profile-name'>
							Navkar Jain
						</Link>
						<NavLinks handleNav={handleNav} />
					</div>
					<ul className='mid-details'>
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								href="#"
								to='home'
								className='mid-links'>
								<FaHome className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									Home
								</span>
							</Link>
						</li>
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								to='about'
								href="#"
								className='mid-links'>
								<FiUser className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									About
								</span>
							</Link>
						</li>
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								to='experience'
								href="#"
								className='mid-links'>
								<FaLaptop className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									Experiences
								</span>
							</Link>
						</li>					
						
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								to='skills'
								href="#"
								className='mid-links'>
								<FaLaptop className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									Skills
								</span>
							</Link>
						</li>
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								to='services'
								href="#"
								className='mid-links'>
								<BiServer className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									Services
								</span>
							</Link>
						</li>
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								to='works'
								href="#"
								className='mid-links'>
								<BiBookContent className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									Projects
								</span>
							</Link>
						</li>
						<li>
							<Link
								activeClass='active'
								spy={true}
								smooth={true}
								offset={0}
								duration={500}
								to='contact'
								href="#"
								className='mid-links'>
								<BiEnvelope className='mid-icon' />
								<span className='mid-link' onClick={handleNav}>
									Contact
								</span>
							</Link>
						</li>
					</ul>
					{/* <div className='copy'>
						<small className='copyright'>
							© Copyright ©2022 <br /> All rights reserved |
						</small>
					</div> */}
				</motion.div>
			</motion.nav>
		</AnimatePresence>
	);
};

export default Navbar;
